/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{LayerViewPerformanceInfo as e}from"./support/LayerViewPerformanceInfo.js";class t extends e{constructor(e,t,s,r,o,a){super(e.usedMemory,e.displayedFeatures,e.totalFeatures,e.maximumFeatures,e.nodes,e.core),this.storedFeatures=t,this.totalVertices=s,this.partial=r,this.mode=o,this.symbolComplexity=a}}export{t as FeatureLayerViewPerformanceInfo};
